export default "__VITE_ASSET__ZhwOTtYj__"